import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Container: ComponentStyleConfig = {
    baseStyle: {
        maxWidth: '85rem',
    },
};
